<template>
    <div class="page-setting has-bc biz-edit-landlord-comp">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <div class="loading-wrap">
                    <btn-loading v-if="status.isDisable"></btn-loading>
                    <button class="default-button publish" @click="saveData" :disabled="status.isDisable">儲存</button>
                </div>
            </div>
        </div>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                屋主基本資料
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 屋主姓名
                        </div>
                        <span v-show="error.name" class="error-with-title">{{error.name}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.name}" type="text" v-model="insertData.name" placeholder="請輸入員工真實姓名">
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 合約姓名
                        </div>
                        <span v-show="error.nameForContract" class="error-with-title">{{error.nameForContract}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.nameForContract}" type="text" v-model="insertData.nameForContract" placeholder="請輸入屋主姓名">
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 身分證字號
                        </div>
                        <span v-show="error.idNumber" class="error-with-title">{{error.idNumber}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.idNumber}" type="text" v-model="insertData.idNumber" placeholder="請輸入身分證字號">
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 出生日期
                        </div>
                        <span v-show="error.birthday" class="error-with-title">{{error.birthday}}</span>
                    </label>
                    <div class="input-arear">
                        <date-picker v-model="insertData.birthday" :class="{'active': insertData.birthday != '', error: error.birthday}" placeholder="請選擇日期"  value-type="format" format="YYYY-MM-DD"></date-picker>
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 性別
                        </div>
                        <span v-show="error.isMale" class="error-with-title">{{error.isMale}}</span>
                    </label>
                    <div class="input-arear flex-group">
                        <border-btn-radio :class="{active: insertData.isMale == true}" v-model="insertData.isMale" :isPropChecked="true"  :val="true" checkboxMsg="男" ></border-btn-radio>
                        <border-btn-radio :class="{active: insertData.isMale == false}" v-model="insertData.isMale" :isPropChecked="false"  :val="false" checkboxMsg="女" ></border-btn-radio>
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 屋主簽名
                        </div>
                        <span v-show="error.isMale" class="error-with-title">{{error.isMale}}</span>
                    </label>
                    <div class="input-arear flex-group">
                        <upload-landlord-sign></upload-landlord-sign>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                屋主聯絡資訊
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 住家電話
                        </div>
                        <span v-show="error.telephone" class="error-with-title">{{error.telephone}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.telephone}" type="text" v-model="insertData.telephone" placeholder="請輸入住家電話">
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 手機號碼
                        </div>
                        <span v-show="error.mobilePhone" class="error-with-title">{{error.mobilePhone}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.mobilePhone}" type="text" v-model="insertData.mobilePhone" placeholder="請輸入手機號碼">
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 電子郵件
                        </div>
                        <span v-show="error.email" class="error-with-title">{{error.email}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.email}" type="text" v-model="insertData.email" placeholder="請輸入電子郵件">
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> Line ID
                        </div>
                        <span v-show="error.lineId" class="error-with-title">{{error.lineId}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.lineId}" type="text" v-model="insertData.lineId" placeholder="請輸入Line ID">
                    </div>
                </div>
                <div class="house-address">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span>
                            連絡地址
                        </div>
                        <span v-show="error.address" class="error-with-title">{{error.address}}</span>
                    </label>
                    <div class="input-arear">
                        <rent-select :class="{error: error.countyErr}" class="select-scroll" refName="county" :selectMsg="insertData.cityName?insertData.cityName:'請選擇縣市'" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                            <ul>
                                <li v-for="(county, index) in counties" :key="index" :data-id="index" :data-name="county">
                                    {{county}}
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select :class="{error: error.districtErr}" class="select-scroll" refName="district" :selectMsg="insertData.districtName?insertData.districtName:'請選擇區域'" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="address.district.state">
                            <ul>
                                <li v-for="(district, index) in districts" :key="index" :data-id="district.districtCid" :data-name="district.districtName">
                                    {{district.districtName}}
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select :class="{error: error.roadStreetErr}" class="select-scroll select-road" refName="road" :selectMsg="insertData.roadName?insertData.roadName:'請選擇路名'" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="address.road.state">
                            <ul>
                                <div class="road-filter">
                                    <img class="search" src="@/assets/img/icon/search_gray.svg" alt="">
                                    <input v-model="filter.road" placeholder="搜尋路段" type="text">
                                </div>
                                <li v-for="(road, index) in filterRoad" :key="index" :data-id="road.roadStreetCid" :data-name="road.roadStreetName">
                                    {{road.roadStreetName}}
                                </li>
                            </ul>
                        </rent-select>
                        <div class="lane">
                            <input type="text" v-model="insertData.lane" placeholder="輸入幾巷">
                            <span>巷</span>
                        </div>
                        <div class="alley">
                            <input type="text" v-model="insertData.alley" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="輸入幾弄">
                            <span>弄</span>
                        </div>
                        <div class="number">
                            <input :class="{error: error.numberErr}" type="text" v-model="insertData.number"  placeholder="輸入幾號">
                            <span>號之</span>
                        </div>
                        <div class="number">
                            <input type="text" v-model="insertData.dash" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="輸入之幾">
                        </div>
                        <div class="floor">
                            <input :class="{error: error.floorErr}" type="text" v-model="insertData.floor" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="輸入樓層">
                            <span>樓之</span>
                        </div>
                        <div class="room">
                            <input type="text" v-model="insertData.room" >
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                其他
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 對帳日期
                        </div>
                        <span v-show="error.reconcileDayOfMonth" class="error-with-title">{{error.reconcileDayOfMonth}}</span>
                    </label>
                    <div class="input-arear">
                        <rent-select class="select-scroll" refName="date" :selectMsg="insertData.reconcileDayOfMonth?'每月 '+insertData.reconcileDayOfMonth+' 號':'請選擇對帳日期'" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                            <ul>
                                <li v-for="n in 31" :key="n" :data-id="n">
                                    每月 {{n}} 號
                                </li>
                            </ul>
                        </rent-select>
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 開發人員
                        </div>
                        <span v-show="error.developer" class="error-with-title">{{error.developer}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.developer}" type="text" v-model="insertData.developer" placeholder="請輸入開發人員">
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 備註
                        </div>
                        <span v-show="error.remark" class="error-with-title">{{error.remark}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.remark}" type="text" v-model="insertData.remark" placeholder="請輸入備註">
                    </div>
                </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import borderBtnRadio from '@/components/widge/borderBtnRadio.vue';
import DatePicker from 'vue2-datepicker';
import uploadLandlordSign from '@/components/bussiness/mgtCategory/landlordMgt/uploadLandlordSign.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            insertData: {
                id: null,
                nameForContract: null,
                name: null,
                idNumber: null,
                cityName: null,
                districtName: null,
                roadName: null,
                alley: null,
                lane: null,
                number: null,
                dash: null,
                floor: null,
                room: null,
                telephone: null,
                mobilePhone: null,
                birthday: null,
                isMale: null,
                remark: null,
                email: null,
                lineId: null,
                developer: null,
                reconcileDayOfMonth: null
            },
            error: {
                name: null,
                nameForContract: null,
                idNumber: null,
                cityName: null,
                districtName: null,
                roadName: null,
                alley: null,
                lane: null,
                number: null,
                dash: null,
                floor: null,
                room: null,
                telephone: null,
                mobilePhone: null,
                birthday: null,
                isMale: null,
                remark: null,
                email: null,
                lineId: null,
                developer: null,
                reconcileDayOfMonth: null
            },
            address: {
                county: {
                    state: false,
                    msg: '縣市'
                },
                district: {
                    state: false,
                    msg: '區域'
                },
                road: {
                    state: false,
                    msg: '路名'
                }
            },
            filter: {
                road: null,
                group: null,
                agent: null,
            },
            status: {
                isDisable: false,
            },
            isDefault: false
        }
    },
    mounted () {
        this.getInfo(this.$route.query.cId)
    },
    destroyed () {
        this.$store.dispatch('setBizLandlordInfoDefault')
    },
    watch: {
        insertData: {
            handler: function (newValue, oldValue) {
                if(newValue.email){
                    let isMail = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
                    if (!isMail.test(newValue.email)) {
                        this.error.email = '電子郵件格式錯誤';
                    }else{
                        this.error.email = null;
                    }
                }
                if(newValue.name){
                    this.error.name = null;
                }
                if(newValue.idNumber){
                    if(this.checkTwID(newValue.idNumber)){
                        this.error.idNumber = null
                    }else{
                        this.error.idNumber = '身分證格式錯誤'
                    }
                }
                let phoneReg = /^09[0-9]{8}$/;
                if( newValue.mobilePhone ){
                    if(!phoneReg.test(newValue.mobilePhone) || newValue.mobilePhone.length > 10 ) {
                        this.error.mobilePhone = '格式錯誤';
                    }else{
                        this.error.mobilePhone = null;
                    }
                }
                if( newValue.telephone ){
                    if(this.checkStringLessThanNum(newValue.telephone, 10)) {
                        this.error.telephone = null;
                    }else{
                        this.error.telephone = '限10個字元以內';
                    }
                }
            },
            deep: true,
        },
        landlordInfo: {
            handler: function (val) {
                if(val){
                    this.insertData.id = val.id
                    this.insertData.name = val.name
                    this.insertData.nameForContract = val.nameForContract
                    this.insertData.idNumber = val.idNumber
                    this.insertData.cityName = val.cityName
                    this.insertData.districtName = val.districtName
                    this.insertData.roadName = val.roadName
                    this.insertData.alley = val.alley
                    this.insertData.lane = val.lane
                    this.insertData.number = val.number
                    this.insertData.dash = val.dash
                    this.insertData.floor = val.floor
                    this.insertData.room = val.room
                    this.insertData.telephone = val.telephone
                    this.insertData.mobilePhone = val.mobilePhone
                    this.insertData.birthday = val.birthday
                    this.insertData.isMale = val.isMale
                    this.insertData.remark = val.remark
                    this.insertData.email = val.email
                    this.insertData.lineId = val.lineId
                    this.insertData.developer = val.developer
                    this.insertData.reconcileDayOfMonth = val.reconcileDayOfMonth
                }
            },
            deep: true,
        }
    },
    methods: {
       getSelectId: function (value) {
            console.log(value)
            if ( value.ref == 'county' ){
                //區域及縣市變為預設
                this.address.district.state = true
                this.address.road.state = true
                this.address.district.msg = '所有區域'
                this.address.road.msg = '所有路段'
                this.insertData.districtName = null
                this.insertData.roadName = null

                this.insertData.cityName = value.name
                this.$store.dispatch('getDistrict',(parseInt(value.id)+1))
            }else if ( value.ref == 'district' ){
                this.address.road.state = true
                this.address.road.msg = '所有路段'
                this.address.district.state = false
                this.insertData.roadName = null
                this.insertData.districtName = value.name
                this.$store.dispatch('getRoad',(parseInt(value.id)))
            }else if ( value.ref == 'road' ){
                this.address.road.state = false

                this.insertData.roadName = value.name
            }else if ( value.ref == 'date' ){
                this.insertData.reconcileDayOfMonth = value.id
            }
        },
        getInfo: function (id) {
            this.$store.dispatch('getBizLanlordInfo', id)
        },
        checkInput: function () {
            if(!this.insertData.name){
                this.error.name = '請輸入屋主姓名';
            }else{
                this.error.name = null;
            }

            if(
                this.insertData.name != null &&
                this.error.name == null &&
                this.error.idNumber == null &&
                this.error.city == null &&
                this.error.district == null &&
                this.error.roadStreet == null &&
                this.error.alley == null &&
                this.error.lane == null &&
                this.error.number == null &&
                this.error.dash == null &&
                this.error.floor == null &&
                this.error.room == null &&
                this.error.telephone == null &&
                this.error.mobilePhone == null &&
                this.error.birthday == null &&
                this.error.isMale == null &&
                this.error.remark == null &&
                this.error.email == null &&
                this.error.lineId == null &&
                this.error.developer == null &&
                this.error.reconcileDayOfMonth == null 
            ){
                return true
            }else{
                return false
            }
         
        },
        saveData: function () {
            console.log(this.checkInput())
            if(this.checkInput()){
                this.status.isDisable = true
                this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})

                this.$store.dispatch('insertBizLandlord', this.insertData)
                .then(res => {
                    this.status.isDisable = false
                    if( res.data.status == "SUCCESS" ){
                        this.$router.push({ name: 'bizLandlordMgtDefault'})
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '成功儲存屋主',type: 'success'})
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                })
            }
        },
        checkTwID: function (id){
            //建立字母分數陣列(A~Z)
            var city = new Array(
                1,10,19,28,37,46,55,64,39,73,82, 2,11,
                20,48,29,38,47,56,65,74,83,21, 3,12,30
            )
            id = id.toUpperCase();
            // 使用「正規表達式」檢驗格式
            if (id.search(/^[A-Z](1|2)\d{8}$/i) == -1) {
                return false;
            } else {
                //將字串分割為陣列(IE必需這麼做才不會出錯)
                id = id.split('');
                //計算總分
                var total = city[id[0].charCodeAt(0)-65];
                for(var i=1; i<=8; i++){
                    total += eval(id[i]) * (9 - i);
                }
                //補上檢查碼(最後一碼)
                total += eval(id[9]);
                //檢查比對碼(餘數應為0);
                return ((total%10 == 0 ));
            }
        },
    },
    computed: {
        filterRoad: function () {
            return this.roads.filter((road) => {
                // console.log(road.roadStreetName)
                if( this.filter.road ){
                    if(road.roadStreetName.includes(this.filter.road)){
                        return road
                    }
                }else{
                    return road
                }
            });
        },
        ...mapGetters({
            counties: 'COUNTY_RESULT',
            districts: 'DISTRICTS_RESULT',
            roads: 'ROAD_RESULT',
            bizAuth: 'GET_BIZ_AUTH',
            landlordInfo: 'GET_BIZ_LANDLORD_INFO',
        })
    },
    components: {
        toogleBlock,
        RentSelect,
        btnLoading,
        borderBtnRadio,
        DatePicker,
        uploadLandlordSign
    }
}
</script>
<style lang="scss">
    .biz-edit-landlord-comp{
        margin-bottom: 230px;
        .page-header{
            .btn-group{
                .loading-wrap{
                    position: relative;
                    width: 100%;
                    .default-button{
                        width: 120px;
                        padding: 14px 0 14px 0;
                    }
                    .btn-loading{
                        left: 5px;
                        top: 6px;
                    }
                }
            }
        }
        .toggle-block > .toogle-body {
            padding: 0 60px 24px 24px;
        }
        .must-fill-alarm{
            position: relative;
            display: flex;
            align-items: center;
            height: 72px;
            margin-bottom: 20px;
            border-radius: 6px;
            box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
            border: solid 1px #f3f3f3;
            background-color: #ffffff;
            color: #676362;
            padding: 0 24px;
            .star{
                color: #fc7171;
                margin: 0 2px;
            }
            img{
                margin-right: 2px;
            }
        }
        span.error{
            right: 0;
            top: -27px;
            left: unset;
            bottom: unset;
        }
        .row-block {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            .mx-datepicker {
                width: 424px;
            }
            .house-address{
                >label{
                    width: 1044px;
                }
                .input-arear{
                    position: relative;
                    margin-bottom: 14px;
                    display: flex;
                    flex-wrap: wrap;
                    > div{
                        margin-right: 8px;
                        margin-bottom: 16px;
                    }
                    > div:nth-child(-n+2){
                        width: 196px;
                    }
                    > div:nth-child(n+4){
                        color: #525956;
                        input{
                            width: 196px;
                            height: 44px;
                            margin-bottom: 0px;
                        }
                    }
                    .biz-rent-select{
                        box-sizing: border-box;
                    }
                    .select-road{
                        width: 196px;
                    }
                }
                
            }
        }
        .col2-input {
            position: relative;
            width: 424px;
            margin-bottom: 24px;
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/landlordMgt/editLandlordComp.vue